import { useState } from "react";
import { back } from "./router";
import { IconChevronLeft, IconUserSilhouette } from "./icons";
import { CabinetSheet } from "./cabinet-sheet";

export function SectionTitle({
  title,
  showBack = true,
  showProfile = true,
}: {
  title: string;
  showBack?: boolean;
  showProfile?: boolean;
}) {
  const [open, setOpen] = useState(false);
  return (
    <header className="mx-auto flex w-full max-w-md items-center gap-3 px-4 pb-2 pt-4 sm:max-w-xl sm:px-5 sm:pt-6 lg:max-w-3xl lg:px-8 xl:max-w-4xl">
      {showBack ? (
        <button
          type="button"
          onClick={back}
          aria-label="Retour"
          className="inline-flex size-11 shrink-0 items-center justify-center rounded-full bg-[var(--overlay-frost)] text-[var(--text-1)] shadow-sm ring-1 ring-[var(--border-1)] backdrop-blur-md transition active:scale-95"
        >
          <IconChevronLeft width={24} height={24} strokeWidth={2.5} />
        </button>
      ) : null}
      <h1 className="min-w-0 flex-1 truncate text-2xl font-bold tracking-tight text-[var(--text-1)] sm:text-3xl">
        {title}
      </h1>
      {showProfile ? (
        <button
          type="button"
          onClick={() => setOpen(true)}
          aria-label="Réglages"
          className="inline-flex size-11 shrink-0 items-center justify-center rounded-full bg-[var(--overlay-frost)] text-[var(--text-2)] shadow-sm ring-1 ring-[var(--border-1)] backdrop-blur-md transition active:scale-95"
        >
          <IconUserSilhouette width={22} height={22} />
        </button>
      ) : null}
      <CabinetSheet open={open} onClose={() => setOpen(false)} />
    </header>
  );
}
